interface PricedOffer {
  quote?: { selectedOption?: string | null } | null;
  options?:
    | {
        type?: string | null;
        homeTotal?: number | null;
        autoTotal?: number | null;
        condoTotal?: number | null;
      }[]
    | null;
}

export const getQuoteFriendlySelectedOption = (selectedOption: string | null | undefined) =>
  selectedOption === 'HB' || selectedOption === 'AB' ? 'HA' : selectedOption;

// Bundle-to-existing-customer selections (HB/AB) use the HA option's premiums.
// Missing prices stay absent; a genuine zero premium must survive.
export const buildPremiumProperties = (
  offer: PricedOffer | null | undefined,
  optionType = offer?.quote?.selectedOption
) => {
  const pricedType = getQuoteFriendlySelectedOption(optionType);
  const option = offer?.options?.find((candidate) => candidate?.type === pricedType);
  return option
    ? {
        homeTotal: option.homeTotal ?? undefined,
        autoTotal: option.autoTotal ?? undefined,
        condoTotal: option.condoTotal ?? undefined
      }
    : {};
};
